import { AfterViewChecked, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { Projekt, UserInfo } from 'src/app/api/models';
import { AppConfig } from 'src/app/config/app-config';
import { AppConfigService } from 'src/app/config/app-config.service';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { ThemeService } from 'src/app/core/services/theme/theme.service';
import { Tutorials } from 'src/app/core/services/tutorial/models/tutorials';
import { CurrentProjektService } from 'src/app/projekter/services/current-projekt/current-projekt.service';

@Component({
  selector: 'bom-layout-page',
  templateUrl: './layout-page.component.html',
  styleUrls: ['./layout-page.component.scss'],
})
export class LayoutPageComponent implements OnInit, AfterViewChecked {
  title = 'Byg og Miljø';
  appConfig: AppConfig;
  Tutorials = Tutorials;

  userInfo$: Observable<UserInfo>;
  url$: Observable<string>;
  isFrontpage$: Observable<boolean>;
  showFooter$: Observable<boolean>;
  isNeutralCss$: Observable<boolean>;
  projekt$: Observable<Projekt>;
  @Input()
  isMobileSigning$: BehaviorSubject<boolean>;

  constructor(
    public authService: AuthService,
    private router: Router,
    private currentProjektService: CurrentProjektService,
    private appConfigService: AppConfigService,
    private themeService: ThemeService,
    private changeDetector: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.appConfig = this.appConfigService.getConfig();

    this.userInfo$ = this.authService.userInfo$.asObservable();
    this.projekt$ = this.currentProjektService.projekt$;
    this.isNeutralCss$ = this.themeService.themeCss$.pipe(map(themeCss => themeCss === 'neutral'));

    this.url$ = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(event => event as NavigationEnd),
      map(event => event.url)
    );

    this.isFrontpage$ = this.url$.pipe(map(url => url === '/'));
    this.showFooter$ = this.url$.pipe(
      map(
        url =>
          url.startsWith('/hjaelp') ||
          url === '/' ||
          (url.includes('/digitalsignering/') && !this.isMobileSigning$)
      )
    );
  }

  // If we omit this part, then we will get the dreaded ExpressionChangedAfterItHasBeenCheckedError on projekt pages
  ngAfterViewChecked() {
    this.changeDetector.detectChanges();
  }

  login() {
    this.authService.login(this.router.url);
  }

  logout() {
    this.authService.logout();
  }
}
